import { Schema, number, string } from 'lib/schema';

export default class ShowStatsFollowers extends Schema {
  @string id;

  @number followers;
}
